import styled from 'styled-components';

export interface IconColorSet {
  primaryColor?: string;
  bgColor?: string;
}

export interface IconStyle extends IconColorSet {
  hover?: IconColorSet;
  active?: IconColorSet;
}

export interface IconProps {
  style?: IconStyle;
  size?: string;
  active?: boolean;
  [key: string]: unknown;
}

type SvgWrapperProps = {
  size?: string;
  active?: boolean;
  style?: IconStyle;
};

const replaceColor =
  (value: string, colorProp: 'primaryColor' | 'bgColor') =>
    ({ active, style: styleProp = {}, ...props }: SvgWrapperProps) => {
      const primaryColor = styleProp.primaryColor || 'currentColor';
      const bgColor = styleProp.bgColor || 'transparent';
      const style = {
        primaryColor,
        bgColor,
        hover: {
          primaryColor: (styleProp.hover && styleProp.hover.primaryColor) || primaryColor,
          bgColor: (styleProp.hover && styleProp.hover.bgColor) || bgColor,
        },
        active: {
          primaryColor: (styleProp.active && styleProp.active.primaryColor) || primaryColor,
          bgColor: (styleProp.active && styleProp.active.bgColor) || bgColor,
        },
      };

      return ['fill', 'stroke']
        .map(
          (attr) =>
            `[${attr}="${value}"] {
          ${attr}: ${active ? style.active[colorProp] : style[colorProp]};
        }
        &:hover {
          [${attr}="${value}"] {
            ${attr}: ${active && style.hover ? style.active[colorProp] : style.hover[colorProp]};
          }
        }`,
        )
        .join('\n');
    };

export const SvgWrapper = styled.span<SvgWrapperProps>`
  display: inline-block;
  font-size: ${(props) => props.size};
  height: 1em;
  width: 1em;

  ${replaceColor('fj-icons-primary-color', 'primaryColor')}
  ${replaceColor('fj-icons-bg-color', 'bgColor')}
`;

export const iconColors = {
  primaryColor: '#1a808e',
  bgColor: '#332e30',
  hoverPrimaryColor: '#0f484c',
  hoverBgColor: '#332e30',
  activePrimaryColor: '#8eaeb2',
  activeBgColor: '#4c4749',
};

export const iconStyle = {
  primaryColor: iconColors.primaryColor,
  bgColor: iconColors.bgColor,
  hover: {
    primaryColor: iconColors.hoverPrimaryColor,
    bgColor: iconColors.hoverBgColor,
  },
  active: {
    primaryColor: iconColors.activePrimaryColor,
    bgColor: iconColors.activeBgColor,
  },
};
